export default __webpack_public_path__ + "static/media/charm-s5.c45bb789.png";